import React, { useState, useEffect, useContext, useMemo } from 'react';
import { Message, Button } from 'semantic-ui-react';
import Loading from '../../../components/Loading';
import CenterCell from '../../../components/table/CenterCell';
import EditProject from './EditProject';
import { getAPI, postAPI, putAPI } from '../../../libs/fetchAPI';
import AppContext from '../../../context/HeaderContext';
import BasicPaginatedTable from '../../../components/table/BasicPaginatedTable';

function Projects() {
	const { current_organization_id }            = useContext(AppContext);
	const [ loading, setLoading ]                = useState(true);
	const [ saving, setSaving ]                  = useState(false);
	const [ showEditModal, setShowEditModal ]    = useState(false);
	const [ current_project, setCurrentProject ] = useState({ title : `` });
	const [ projects, setProjects ]              = useState([]);

	useEffect(() => {
		setLoading(true);
		getAPI(`/projects?organization_id=${current_organization_id}`)
			.then(({ data }) => {
				setProjects(data);
				setLoading(false);
			});
	}, [current_organization_id])

	function handleCloseEditModal() {
		setShowEditModal(false);
	}

	function handleEditProject(id) {
		setShowEditModal(true);

		const project = projects.find(project => project.id === id)
		setCurrentProject(project);
	}

	function updateCurrentProject(e) {
		setCurrentProject({
			...current_project,
			[e.target.name] : e.target.value
		});
	}

	function handleSaveProject(insert = false) {
		setSaving(true);
		let response  = null;
		const request = {
			...current_project,
			...{ organization_id : current_organization_id }
		};

		if(current_project.id) {
			response = putAPI(`/projects/${current_project.id}`, request);
		}
		else {
			response = postAPI(`/projects`, request);
		}

		response.then(({ data }) => {
			if(request.id) {
				setProjects(projects.map(project => project.id === request.id ? request : project));
			}
			else {
				setProjects([...projects, data[0]])
			}

			setShowEditModal(false);
			setCurrentProject({ title : null });
			setSaving(false);
		});
	}

	/* eslint-disable */
	const columns = useMemo(() => [
		{
			Header   : `Project`,
			accessor : `title`,
		},
		{
			Header   : `Project ID (for api access)`,
			accessor : `_id`,
			Cell     : ({ cell }) => {
				return <span>{cell.row.values.id}</span>
			}
		},
		{
			Header         : ``,
			accessor       : `id`,
			collapse       : true,
			disableFilters : true,
			Cell           : ({ cell }) => <CenterCell><Button primary onClick={() => handleEditProject(cell.value)}>Edit</Button></CenterCell>
		}
	], [projects]);
	/* eslint-enable */

	if(loading) {
		return <Loading />
	}

	return (
		<>
			<EditProject
				current_project={current_project}
				open={showEditModal}
				handleClose={handleCloseEditModal}
				handleSaveProject={handleSaveProject}
				updateCurrentProject={updateCurrentProject}
				saving={saving}
			/>

			<Message info>
				Projects are a way to separate test runs between different codebases. You can have an unlimited amount of projects.
			</Message>
			<Button
				positive
				onClick={() => {
					setShowEditModal(true);
					setCurrentProject({ title : `` });
				}}
			>
				Add New Project
			</Button>

			<BasicPaginatedTable
				columns={columns}
				data={projects}
				default_page_size="15"
			/>
		</>
	);
}

export default Projects;
